export default "__VITE_ASSET__b7pbb2rK__"